import React from "react";
import { ThemeProvider } from "styled-components";
import { defaultTheme } from "./defaultTheme";

export const FlightPathThemeProvider: React.FC<ReactProps> = ({ children }) => (
  <ThemeProvider theme={defaultTheme}>{children}</ThemeProvider>
);
